import styled from 'styled-components';

export const RoofsInputArea = styled.div`
  display: grid;
  grid-template-columns: 3fr 3fr 3fr;
  grid-gap: 20px;
  gap: 20px;
  align-items: end;
`;
